import styled from "styled-components/macro";
import { makeStyles } from "@mui/styles";
import { md } from "../../styles/responsive";
import { FormControl } from "@mui/material";
// import banner002 from "../../assets/images/banner002.png";

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CarouselIMG = styled.img`
  width: 100%;
  display: flex;
`;

export const FormInputSelectHeader = styled(FormControl)`
  display: block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #fff;
  background-clip: padding-box;
  border: 0!important;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  // margin-bottom: 1rem !important;
  .MuiOutlinedInput-input {
    font-size: 24px;
    font-weight:600;
    min-height: auto;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0!important;
  }
  .MuiSelect-select{
    min-height: auto !important;
  }
  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
`;

export const FormInputSelect = styled(FormControl)`
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #fff;
  background-clip: padding-box;
  // border: 1px solid #c5c5c5;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  // margin-bottom: 1rem !important;

  .MuiInput-underline:before {
    border-bottom: none !important;
  }
  .MuiInput-underline:after {
    border-bottom: none !important;
  }
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiInputBase-root {
    font-weight: 500 !important;
  }
  .MuiInput-underline {
    &:before {
      position: relative !important;
    }
  }
`;

const config = {
  theFontTitle: {
    fontSize: "34px",
    ...md("sm", {
      fontSize: "34px",
    }),
    ...md("md", {
      fontSize: "54px",
    }),
    ...md("lg", {
      fontSize: "64px",
    }),
  },

  theFont: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      textAlign: "justify",
    }),

    ...md("lg", {
      fontSize: "14px",
      textAlign: "justify",
    }),
  },

  theFont_: {
    fontSize: "14px",
    ...md("md", {
      fontSize: "14px",
      width: "60%",
    }),

    ...md("xmd", {
      fontSize: "14px",
      width: "50%",
    }),

    ...md("lg", {
      fontSize: "14px",
      width: "55%",
    }),
  },

  theHeadTitle: {
    color: "#FFF !important",
  },

  theFlexHeader: {
    display: "block",
    // marginBottom: "1rem",

    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: 'space-between'
      // width: "50%"
    }),
  },

  theHeaderSelect: {
    width: "100%",

    ...md("md", {
      width: "20%"
    }),
  },

  theCardWarehouse: {
    background: "#AC5500",
    padding: "1rem",
    borderRadius: "6px",
  },

  theCardUser: {
    background: "#FF9200",
    padding: "1rem",
    borderRadius: "6px",
  },

  theWx: {
    width: "100%",
    marginBottom: "1rem",
    ...md("md", {
      width: "20%",
      marginBottom: 0,
    }),
  },

  theWxBtn: {
    width: "100%",
    ...md("md", {
      width: "15%",
      margin: "0 auto"
    }),
  },

  theTab: {
    padding: ".4rem 1.5rem",
  },

  theTabActive: {
    fontWeight: "600",
    color: "#FF9200",
    padding: ".4rem 1.5rem",
  },

  theFlexAction: {
    display: "block",
    marginBottom: "1rem",

    ...md("md", {
      display: "flex",
      alignItems: "center",
      // width: "50%"
    }),
  },

  theFlex_: {
    display: "block",

    ...md("md", {
      display: "flex",
      alignItems: "center",
    }),
  },

  theFlexBtn: {
    display: "block",
    marginBottom: "1rem",
    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }),
  },

  theFlexBtn_: {
    display: "block",
    ...md("md", {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }),
  },

  theCustomActionBtn: {
    color: "#1A5386",
    background: "#fff",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    borderBottom: "1px solid #1A5386",
    borderRight: "0",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
      borderRight: "1px solid #1A5386",
      borderBottom: "0",
    }),
  },

  theCustomActionBtn_: {
    color: "#1A5386",
    background: "#fff",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    cursor: "pointer",

    ...md("md", {
      //   marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theCustomActionBtnFill: {
    color: "#fff",
    background: "#1A5386",
    padding: ".4rem 1rem",
    display: "flex",
    marginBottom: "1rem",
    borderRadius: "10px",
    cursor: "pointer",

    ...md("md", {
      marginLeft: "1rem",
      marginBottom: 0,
    }),
  },

  theCustomActionBtnFill_: {
    color: "#fff",
    background: "#1A5386",
    padding: ".4rem 1rem",
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: "1rem",
    borderRadius: "10px",
    cursor: "pointer",
    width: "150px"

    // ...md("md", {
    //   marginLeft: "1rem",
    //   marginBottom: 0,
    // }),
  },

  theBottom: {
    margin: "0 0 .8rem 0 !important",
    ...md("md", {
      margin: "0 0.8rem !important",
    }),
  },

  theBox: {
    position: "relative",
    width: "100%",
    overflow: "scroll"
  },

  theRow: {
    ...md("md", {
      display: "flex",
      overflowX: "scroll",
      width: "1440px"
    }),
  },

  theGap: {
    marginRight: "5rem"
  },
  theCard: {
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  },
  theProductImg: {
    position: "relative",
    width: "150px",
    height: '150px',
    margin: "0 0 1rem",
    '& img': {
      width: "100%",
      height: "150px",
      objectFit: "contain"
    }
  },
  theUnderLineLabel: {
    color: "#1a5386!important",
    fontWeight: "600!important",
    textDecoration: "underline",
    cursor: "pointer"
  },
  theSlider: {
    position: "relative",

    // "& .slick-track": {
    //   display: "flex",
    //   flexDirection: "row",
    //   alignItems: "inherit",
    // },
    // "& .slick-slide": {
    //   height: "inherit",
    //   "& > div": {
    //     // height: "100%",
    //   },
    //   "& > div > div": {
    //     // height: "100%",
    //   },
    // },
    // "& .slick-arrow": {
    //   color: "#000",
    //   display: "flex!important",
    //   flexDirection: "row",
    //   alignItems: "center",
    //   justifyContent: "center",
    //   zIndex: 2,

    //   "&:before": {
    //     content: "",
    //     content: "\f053",
    //     display: "block",
    //     width: 24,
    //     height: 24,
    //     // backgroundPosition: "center center",
    //     // backgroundRepeat: "no-repeat",
    //     // backgroundSize: "contain",
    //   },

    //   "&.slick-next": {
    //     right: -38,

    //     ...md("sm", {
    //       right: "-4px",
    //     }),

    //     "&:before": {
    //       content: "",
    //       content: "\f054",
    //       fontFamily: "Font Awesome 5 Free",
    //       fontWeight: 900,
    //       color: "#000",
    //       fontSize: "2rem",
    //     },
    //   },

    //   "&.slick-prev": {
    //     left: -38,

    //     ...md("sm", {
    //       left: "-8px",
    //     }),

    //     "&:before": {
    //       content: "",
    //       content: "\f053",
    //       fontFamily: "Font Awesome 5 Free",
    //       fontWeight: 900,
    //       color: "#000",
    //       fontSize: "2rem",
    //     },
    //   },
    //   "&.slick-disabled": {
    //     opacity: 1,
    //   },
    // },
    // "& .slick-dots": {
    //   position: "static",
    //   marginTop: -40,
    //   width: '40%',

    //   "& li": {
    //     margin: "0 5px",
    //     width: "auto",
    //     height: "auto",

    //     "& button": {
    //       width: 10,
    //       height: 8,
    //       borderRadius: "100px",
    //       backgroundColor: "#fff",
    //       padding: 0,
    //       transition: "all 0.4s",

    //       "@media screen and (min-width: 768px)": {
    //         height: 10,
    //       },

    //       "&:before": {
    //         display: "none",
    //       },
    //     },

    //     "&.slick-active": {
    //       "& button": {
    //         // width: 30,
    //         backgroundColor: '#ED1C24'
    //       },
    //     },
    //   },
    // },
  },
  theSliderVariant: {
    width: "80%",
    margin: "0 auto"
  },
  theImageBox: {
    boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
    margin: "0 10px 0",
    position: "relative"
  },
  theIBImg: {
    width: "100%",
    '& img': {
      width: "100%",
      aspectRatio: "1/1",
      objectFit: "contain",
    }
  },
  theRemove: {
    position: 'absolute',
    width: "30px",
    height: "30px",
    top: "10px",
    right: "10px",
    borderRadius: "50%",
    background: "#C52626",
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    cursor: "pointer"
  }
};

export default makeStyles(config);
